var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1494 2C6.62941 2 2.14941 6.48 2.14941 12C2.14941 17.52 6.62941 22 12.1494 22C17.6694 22 22.1494 17.52 22.1494 12C22.1494 6.48 17.6694 2 12.1494 2ZM12.1494 6C14.0794 6 15.6494 7.57 15.6494 9.5C15.6494 11.43 14.0794 13 12.1494 13C10.2194 13 8.64941 11.43 8.64941 9.5C8.64941 7.57 10.2194 6 12.1494 6ZM12.1494 20C10.1194 20 7.71941 19.18 6.00941 17.12C7.69941 15.8 9.82941 15 12.1494 15C14.4694 15 16.5994 15.8 18.2894 17.12C16.5794 19.18 14.1794 20 12.1494 20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_2415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.149414)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPlan);
export default __webpack_public_path__ + "static/media/account_plan.95eba44646f5b1087f482d918970ac8a.svg";
export { ForwardRef as ReactComponent };